import {useTranslation} from 'react-i18next';

const SEND_ICON_PATH =
  'M20.2346 5.68597C20.6666 4.49097 19.5086 3.33297 18.3136 3.76597L3.70855 9.04797C2.50955 9.48197 2.36455 11.118 3.46755 11.757L8.12955 14.456L12.2926 10.293C12.4812 10.1108 12.7338 10.01 12.996 10.0123C13.2582 10.0146 13.509 10.1197 13.6944 10.3051C13.8798 10.4906 13.9849 10.7414 13.9872 11.0036C13.9895 11.2658 13.8887 11.5184 13.7066 11.707L9.54355 15.87L12.2436 20.532C12.8816 21.635 14.5176 21.489 14.9516 20.291L20.2346 5.68597Z';

export default function SendButton({disabled, className}) {
  const {t} = useTranslation();

  return (
    <button
      type="submit"
      disabled={disabled}
      className={className}
      aria-label={t('campaignChat.chat.send')}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d={SEND_ICON_PATH} fill="white" />
      </svg>
    </button>
  );
}
